import React, { Component, createRef } from "react";
// // Editable
// import { BootstrapTable,TableHeaderColumn } from "react-bootstrap-table";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../../common/validation";

import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { categoriTypes } from "../../StaticData.js";
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../Common/Breadcrumb";
import {
  getUserApi,
  getUnitAPI,
  getPartyApi,
  addStockWithDataEntry,
  updateStockWithDataEntry,
  getCategories,
  getShapes,
} from "../../../api";
// import JangadName from "components/Common/Jangad";
import { withTranslation } from "react-i18next";
class InternalUnitinward extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      validation: "",
      editRowIndex: -1,
      isSubmitTrue: true,
      status:
        props?.location?.query && props.location.query.isEdit != 1
          ? props.location.query.data.mainJangad.status
          : "",
      pieces: 0,
      factoryType:
        "query" in props.location
          ? props.location.query.data.factory.factoryType
          : "",
      factoryId:
        "query" in props.location ? props.location.query.data.factoryId : "",
      factoryList:
        "query" in props.location && props.location.query.data.factory
          ? [props.location.query.data.factory]
          : [],
      dataEntryList:
        "query" in props.location && props.location.query.data.dataEntryStock
          ? [props.location.query.data.dataEntryStock.user]
          : [],
      deliveryBoyList:
        "query" in props.location && props.location.query.data.fromDeliverBoy
          ? [props.location.query.data.fromDeliverBoy]
          : [],
      categoryList:
        "query" in props.location &&
        props.location.query.data.mainJangad.category
          ? [props.location.query.data.mainJangad.category]
          : [],
      salesOfficeList:
        "query" in props.location && props.location.query.data.user
          ? [props.location.query.data.user]
          : [],
      categoryId:
        "query" in props.location
          ? props.location.query.data.mainJangad.categoryId
          : "",
      partyCode: "",
      isSubmit: false,
      selectedParty:
        "query" in props.location
          ? props.location.query.data.mainJangad.party
          : {
              id: "",
              contactPersonName: "",
              mobileNo1: "",
              mobileNo2: "",
              email: "",
            },
      partyList:
        "query" in props.location && props.location.query.data.mainJangad.party
          ? [props.location.query.data.mainJangad.party]
          : [],
      shapesList: [],
      props:
        "query" in props.location
          ? props.location.query
          : {
              isEdit: 1,
            },
      graderList:
        "query" in props.location && props.location.query.data.dataEntryStock
          ? [props.location.query.data.dataEntryStock.dataEntryGraderUser]
          : [],
      notEditableRows:
        "query" in props.location
          ? props.location.query.data.dataEntryStock == null
            ? [1, 2, 3, 4]
            : props.location.query.data.dataEntryStock.stockDataEntryInWards.map(
                x => x.id
              )
          : [1, 2, 3, 4],

      stockList:
        "query" in props.location
          ? props.location.query.data.dataEntryStock == null
            ? [
                {
                  id: 1,
                  srNo: 1,
                  shapeId: "",
                  weight: 0,
                  weightType: "CT",
                  pieces: 1,
                  remarks: "",
                  nextRemarks: "",
                },
                {
                  id: 2,
                  srNo: 2,
                  shapeId: "",
                  weight: 0,
                  weightType: "CT",
                  pieces: 1,
                  remarks: "",
                  nextRemarks: "",
                },
                {
                  id: 3,
                  srNo: 3,
                  shapeId: "",
                  weight: 0,
                  weightType: "CT",
                  pieces: 1,
                  remarks: "",
                  nextRemarks: "",
                },
                {
                  id: 4,
                  srNo: 4,
                  shapeId: "",
                  weight: 0,
                  weightType: "CT",
                  pieces: 1,
                  remarks: "",
                  nextRemarks: "",
                },
              ]
            : props.location.query.data.dataEntryStock.stockDataEntryInWards.sort(
                (a, b) => a.srNo - b.srNo
              )
          : [
              {
                id: 1,
                srNo: 1,
                shapeId: "",
                weight: 0,
                weightType: "CT",
                pieces: 1,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 2,
                srNo: 2,
                shapeId: "",
                weight: 0,
                weightType: "CT",
                pieces: 1,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 3,
                srNo: 3,
                shapeId: "",
                weight: 0,
                weightType: "CT",
                pieces: 1,
                remarks: "",
                nextRemarks: "",
              },
              {
                id: 4,
                srNo: 4,
                shapeId: "",
                weight: 0,
                weightType: "CT",
                pieces: 1,
                remarks: "",
                nextRemarks: "",
              },
            ],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async getStockList() {
    if (this.state.props.isEdit != 3) {
      const factory = await getUnitAPI({
        isInternal: this.state.factoryType == "1" ? true : false,
      });
      this.setState({
        factoryList: factory.data.factories,
      });
    }
    if (this.state.props.isEdit != 1) {
      this.getUserLists();
    }
  }

  async getUserLists() {
    if (this.state.props.isEdit != 3) {
      const grader = await getUserApi({
        roleId: "ROLE0000002",
        factoryId: this.state.factoryId,
      });
      if(grader && grader.data){
        this.setState({
          graderList: grader.data.users
        });
      }
      const dataEntry = await getUserApi({
        roleId: "ROLE0000001",
        factoryId: this.state.factoryId,
      });
      if(dataEntry && dataEntry.data){
        this.setState({
          dataEntryList: dataEntry.data.users
        });
      }
      const deliveryBoys = await getUserApi({
        roleId: "ROLE0000006",
      });
      if(deliveryBoys && deliveryBoys.data){
        this.setState({
          deliveryBoyList: deliveryBoys.data.users,
        });
      }
      const salesOffice = await getUserApi({
        roleId: "ROLE0000007",
      });
      if(salesOffice && salesOffice.data){
        this.setState({
          salesOfficeList: salesOffice.data.users,
        });
      }

    }
  }

  async componentDidMount() {
    this.getStockList();
    if (this.state.props.isEdit != 3) {
      const factory = await getUnitAPI({
        isInternal: this.state.factoryType == "1" ? true : false,
      });
      this.setState({
        factoryList: factory.data.factories,
      });
      const shape = await getShapes();
      this.setState({
        shapesList: [
          { label: "NONE", value: "" },
          ...shape.data.map(x => {
            return {
              label: x.name,
              value: x.id,
            };
          }),
        ],
      });
      const party = await getPartyApi({ page: null, limit: null });
      const categories = await getCategories();
      this.setState({
        partyList: party.data.parties,
        categoryList: categories.data,
      });
    }
  }

  deleteRow(rowIndex) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: [...this.state.stockList],
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
  }

  addRow() {
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: this.state.stockList.length + 1,
          srNo: this.state.stockList.length
            ? this.state.stockList.reduce((prev, curr) => {
                return prev.srNo > curr.srNo ? prev.srNo : curr.srNo;
              }) + 1
            : this.state.stockList.length + 1,
          weight: 0,
          weightType: "CT",
          shapeId: "",
          pieces: 1,
          remarks: "",
          nextRemarks: "",
        },
      ],
      notEditableRows: [
        ...this.state.notEditableRows,
        this.state.stockList.length + 1,
      ],
    });
  }

  handleSubmit = async (e, values) => {
    if (this.state.stockList.filter(x => x.weight > 0 && x.pieces > 0).length) {
      if (this.state.props.isEdit == 1) {
        e.preventDefault();
        values.weightType = "CT";
        delete values.id;
        let temp = {
          fromDeliverBoyId: values.fromDeliverBoyId,
          factoryId: this.state.factoryId,
          userId: values.userId,
          weightType: values.weightType,
          weight: values.weight,
          cycle: 1,
          remarks: values.selfInternalRemarks,
          nextRemarks: values.dataEntryPersonRemarks,
          pieces: values.pieces,
          dataEntryStock: {
            userId: values.dataEntryUserId,
            graderUserId: values.graderUserId,
            remarks: values.dataEntryPersonRemarks,
            nextRemarks: values.graderRemarks,
            stockDataEntryInWards: this.state.stockList.filter(x => {
              if (x.weight > 0 && x.pieces > 0) {
                delete x.id;
                return {
                  shapeId: x.shapeId,
                  weightType: "CT",
                  weight: x.weight,
                  srNo: x.srNo,
                  pieces: x.pieces,
                  remarks: x.remarks,
                  nextRemarks: x.nextRemarks,
                };
              }
            }),
          },
        };
        const data = await addStockWithDataEntry({
          categoryId: this.state.categoryId,
          partyJangadNo: values.partyJangadNo,
          partyId: values.partyId,
          jangads: [temp],
        });
        if (data.success == true) {
          this.setState({
            isSubmitTrue: false,
          });
        }
      } else {
        let temp = {
          id: this.state.props.data.id,
          fromDeliverBoyId: values.fromDeliverBoyId,
          factoryId: this.state.factoryId,
          userId: values.userId,
          partyId: values.partyId,
          remarks: values.selfInternalRemarks,
          nextRemarks: values.dataEntryPersonRemarks,
          weightType: values.weightType,
          weight: values.weight,

          pieces: values.pieces,
          dataEntryStock: {
            id: this.state.props.data.dataEntryStock
              ? this.state.props.data.dataEntryStock.id
              : null,
            userId: values.dataEntryUserId,
            mainJangadId: this.state.props.data.mainJangadId,
            graderUserId: values.graderUserId,
            remarks: values.dataEntryPersonRemarks,
            nextRemarks: values.graderRemarks,
            stockDataEntryInWards: this.state.stockList.map(x => {
              return x;
            }),
          },
        };
        let id = this.state.props.data.id;
        const data = await updateStockWithDataEntry({
          jangads: [temp],
          status: this.state.status == "true" ? true : false,
          categoryId: this.state.categoryId,
          partyJangadNo: values.partyJangadNo,
          id: id,
          partyId: this.state.selectedParty.id,
          mainJangadId: this.state.props.data.mainJangadId,
        });
        if (data.success == true) {
          this.setState({
            isSubmitTrue: false,
          });
        }
      }
    }
  };

  externalSubmit = async (e, values) => {
    e.preventDefault();
    if (this.state.props.isEdit == 1) {
      values.weightType = "CT";
      delete values.id;
      let temp = {
        fromDeliverBoyId: values.fromDeliverBoyId,
        factoryId: this.state.factoryId,
        userId: values.userId,
        weightType: values.weightType,
        weight: values.weight,
        cycle: 1,
        remarks: values.selfInternalRemarks,
        nextRemarks: values.dataEntryPersonRemarks,
        pieces: values.pieces,
      };
      const data = await addStockWithDataEntry({
        categoryId: this.state.categoryId,
        partyJangadNo: values.partyJangadNo,
        partyId: values.partyId,
        jangads: [temp],
      });
      if (data.success == true) {
        this.setState({
          isSubmitTrue: false,
        });
      }
    } else {
      values.weightType = "CT";
      delete values.id;
      let temp = {
        id: this.state.props.data.id,
        fromDeliverBoyId: values.fromDeliverBoyId,
        factoryId: this.state.factoryId,
        userId: values.userId,
        weightType: values.weightType,
        weight: values.weight,
        cycle: 1,
        remarks: values.selfInternalRemarks,
        nextRemarks: values.dataEntryPersonRemarks,
        pieces: values.pieces,
      };
      let id = this.state.props.data.id;
      const data = await updateStockWithDataEntry({
        jangads: [temp],
        status: this.state.status == "true" ? true : false,
        categoryId: this.state.categoryId,
        partyJangadNo: values.partyJangadNo,
        id: id,
        partyId: this.state.selectedParty.id,
        mainJangadId: this.state.props.data.mainJangadId,
      });
      if (data.success == true) {
        this.setState({
          isSubmitTrue: false,
        });
      }
    }
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "manage stock";
    //meta title
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("ID")}`,
        footer: "",
        hidden: true,
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        footer: `${this.state.stockList.length}`,
        sort: true,
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },
      {
        dataField: "shapeId",
        text: `${this.props.t("Shapes")}`,
        editable: true,
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.state.shapesList,
        },
        formatter: (cell, row) => {
          if (cell == "") {
            return "NONE";
          } else if (this.state.props.isEdit != 1 && cell == row.shape?.id) {
            return row.shape.name;
          } else {
            return this.state.shapesList?.filter(x => x.value == cell)[0]
              ?.label;
          }
        },
        style: (cell, row, rowIndex, colIndex) => {
          const color =
            cell == "" && this.state.isSubmit == true ? "red" : "#495057";
          return { color };
        },
      },
      {
        dataField: "remarks",
        text: `${this.props.t("Self Internal Remarks")}`,
        footer: "",
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t("Edit Data")}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //         <button
      //           type="button"
      //           className="bg-transparent border-0 ms-3"
      //           onClick={() => this.deleteRow(rowIndex)}
      //         >
      //           <img src="images/dashboard-images/deleteRow.svg"></img>
      //         </button>
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //       <button
      //         type="button"
      //         className="bg-transparent border-0 ms-3"
      //         onClick={() => this.deleteRow(rowIndex)}
      //       >
      //         <img src="images/dashboard-images/deleteRow.svg"></img>
      //       </button>
      //     </div>
      //   ),
      // },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        footer: "",
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },

      {
        dataField: "remarks",
        text: `${this.props.t("Self Internal Remarks")}`,
        footer: "",
      },
      {
        dataField: "nextRemarks",
        text: `${this.props.t("For Next Person Instruction")}`,
        footer: "",
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows: [...this.state.notEditableRows, row.id],
                    });
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    if (
                      this.state.notEditableRows.length ===
                      this.state.stockList.length
                    )
                      this.setState({
                        notEditableRows: this.state.notEditableRows.filter(
                          x => x != row.id
                        ),
                      });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                type="button"
                className="bg-transparent border-0 ms-3"
                onClick={() => this.deleteRow(rowIndex)}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="btn-group">
            {!this.state.notEditableRows.includes(row.id) ? (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  this.setState({
                    notEditableRows: [...this.state.notEditableRows, row.id],
                  });
                }}
              >
                <img src="images/dashboard-images/print.svg"></img>
              </span>
            ) : (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  if (
                    this.state.notEditableRows.length ===
                    this.state.stockList.length
                  )
                    this.setState({
                      notEditableRows: this.state.notEditableRows.filter(
                        x => x != row.id
                      ),
                    });
                }}
              >
                <img src="images/dashboard-images/edit.svg"></img>
              </span>
            )}
            <button
              className="bg-transparent border-0 ms-3"
              onClick={() => this.deleteRow(rowIndex)}
            >
              <img src="images/dashboard-images/deleteRow.svg"></img>
            </button>
          </div>
        ),
      },
    ];
    const defaultSorted = [
      {
        dataField: "srNo",
        order: "asc",
      },
    ];
    let tempData = this.state?.props?.data;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs
              breadcrumbItem={`${this.props.t("MANAGE STOCK - INWARD")}`}
            />
            <>
              {this.state.factoryType == "1" ? (
                <Card>
                  <Formik
                    enableReinitialize={true}
                    initialValues={
                      this.state.props.isEdit == 1
                        ? {
                            id: "",
                            partyId: this.state.selectedParty.id || "",
                            factoryId: this.state.factoryId || "",
                            userId: "",
                            dataEntryUserId: "",
                            fromDeliverBoyId: "",
                            weight: 0,
                            pieces: this.state.pieces,
                            graderUserId: "",
                            partyJangadNo: "",
                            selfInternalRemarks: "",
                            dataEntryPersonRemarks: "",
                            // remarks: "",
                            graderRemarks: "",
                            factoryType: this.state.factoryType,
                            categoryId: this.state.categoryId,
                          }
                        : {
                            id: this.state.props.data.id,
                            partyId: this.state.props.data.mainJangad.party.id,
                            partyJangadNo:
                              this.state.props.data.mainJangad.partyJangadNo,
                            factoryId: tempData.factory.id,
                            dataEntryUserId: tempData.dataEntryStock
                              ? tempData.dataEntryStock?.userId
                              : "",
                            userId: tempData.user.id,
                            fromDeliverBoyId: tempData.fromDeliverBoyId,
                            weight: tempData.weight,
                            pieces: tempData.pieces,
                            graderUserId: tempData.dataEntryStock
                              ? tempData.dataEntryStock?.graderUserId
                              : "",
                            // remarks: tempData.dataEntryStock ? tempData.dataEntryStock?.remarks : "",
                            graderRemarks: tempData.dataEntryStock
                              ? tempData.dataEntryStock?.nextRemarks
                              : "",
                            selfInternalRemarks: tempData.remarks,
                            dataEntryPersonRemarks: tempData.nextRemarks,
                            categoryId: this.state.categoryId,
                            status:
                              this.state.status == true ? "true" : "false",
                          }
                    }
                    validationSchema={Yup.object().shape({
                      id: Yup.string().notRequired(),
                      partyId: Yup.string().required("This value is required"),
                      factoryId: Yup.string().required(
                        "This value is required"
                      ),
                      userId: Yup.string().required("This value is required"),
                      partyJangadNo: Yup.string().required(
                        "This value is required"
                      ),
                      status: Yup.string().notRequired(),
                      categoryId: Yup.string().required(
                        "This value is required"
                      ),
                      dataEntryUserId: Yup.string().required(
                        "This value is required"
                      ),
                      fromDeliverBoyId: Yup.string().required(
                        "This value is required"
                      ),
                      weight: Yup.number()
                        .min(1)
                        .max(32767)
                        .required("This value is required"),
                      pieces: Yup.number()
                        .min(1)
                        .max(32767)
                        .required("This value is required"),
                      graderUserId: Yup.string().required(
                        "This value is required"
                      ),
                      // remarks: Yup.string().max(512).min(1).max(255).notRequired(),
                      selfInternalremarks: Yup.string()
                        .max(512)
                        .min(1)
                        .max(255)
                        .notRequired(),
                      dataEntryPersonremarks: Yup.string()
                        .max(512)
                        .min(1)
                        .max(255)
                        .notRequired(),
                      graderremarks: Yup.string()
                        .max(512)
                        .min(1)
                        .max(255)
                        .nullable()
                        .notRequired(),
                      unitType: Yup.string().required("This value is required"),
                    })}
                    onSubmit={values => {}}
                  >
                    {({
                      errors,
                      status,
                      touched,
                      values,
                      submitCount,
                      resetForm,
                    }) => (
                      <Form className="needs-validation">
                        <div className="pt-3">
                          <div className="row">
                            <div className="d-md-flex d-block justify-content-between px-4">
                              <div>
                                {this.state.props.isEdit == 1 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.props.t("Add New Stock (Inward)")}
                                  </h4>
                                )}
                                {this.state.props.isEdit == 2 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.props.t("Edit Stock (Inward)")}
                                  </h4>
                                )}
                                {this.state.props.isEdit == 3 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    View Stock (Inward)
                                  </h4>
                                )}
                              </div>
                            </div>
                            <div className="col-xl-8 col-12">
                              <CardBody>
                                <Row>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="factoryType"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Factory(Unit) Type")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        onChange={e =>
                                          this.setState(
                                            {
                                              factoryType: e.target.value,
                                              factoryId: "",
                                              factoryList: [],
                                              dataEntryList: [],
                                              deliveryBoyList: [],
                                              salesOfficeList: [],
                                              graderList: [],
                                            },
                                            () => this.getStockList()
                                          )
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        value={this.state.factoryType}
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.factoryType &&
                                          touched.factoryType
                                            ? " is-invalid"
                                            : "")
                                        }
                                        name="factoryType"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        <option value="1">Internal</option>
                                        <option value="2">External</option>
                                      </Field>
                                      <ErrorMessage
                                        name="factoryType"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="id"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Jangad Id")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.id && touched.id
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={true}
                                        type="text"
                                        name="id"
                                        placeholder="JANGAD0000123"
                                      />
                                      <ErrorMessage
                                        name="id"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Name")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.partyId && touched.partyId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.selectedParty.id}
                                        onChange={e =>
                                          this.setState({
                                            selectedParty:
                                              this.state.partyList.filter(
                                                x => x.id == e.target.value
                                              )[0],
                                          })
                                        }
                                        name="partyId"
                                        as="select"
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.partyList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="partyId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="factoryId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        Unit Name
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.factoryId && touched.factoryId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.factoryId}
                                        onChange={e => {
                                          resetForm({
                                            ...values,
                                            userId: "",
                                            dataEntryUserId: "",
                                            fromDeliverBoyId: "",
                                            graderUserId: "",
                                            factoryType: "",
                                          });
                                          this.setState(
                                            {
                                              factoryId: e.target.value,
                                              dataEntryList: [],
                                              deliveryBoyList: [],
                                              salesOfficeList: [],
                                              graderList: [],
                                            },
                                            () => {
                                              console.log(this.state.factoryId);
                                              this.getUserLists();
                                            }
                                          );
                                        }}
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="factoryId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.factoryList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="factoryId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="categoryId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Category")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10 col-12">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.categoryId &&
                                          touched.categoryId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        name="categoryId"
                                        as="select"
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        value={this.state.categoryId}
                                        onChange={e => {
                                          this.setState({
                                            categoryId: e.target.value,
                                          });
                                        }}
                                      >
                                        <option value="">
                                          Select categories
                                        </option>
                                        {this.state.categoryList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="category"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="pieces"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Total No of Pieces")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.pieces && touched.pieces
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.pieces}
                                        onChange={e => {
                                          this.setState({
                                            pieces: e.target.value,
                                          });
                                        }}
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="number"
                                        onWheel={e => e.target.blur()}
                                        name="pieces"
                                        placeholder="2001"
                                      />
                                      <ErrorMessage
                                        name="pieces"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="weight"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Total Weight")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.weight && touched.weight
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="number"
                                        onWheel={e => e.target.blur()}
                                        name="weight"
                                        placeholder="20.25 CT"
                                      />
                                      <ErrorMessage
                                        name="weight"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="fromDeliverBoyId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        From Delivery Boy
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.fromDeliverBoyId &&
                                          touched.fromDeliverBoyId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="fromDeliverBoyId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.deliveryBoyList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="fromDeliverBoyId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="userId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        Sales Person
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.userId && touched.userId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="userId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.salesOfficeList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="userId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyJangadNo"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Jangad Number")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.partyJangadNo &&
                                          touched.partyJangadNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        readOnly={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="text"
                                        name="partyJangadNo"
                                        placeholder="JANGAD0000123"
                                      />
                                      <ErrorMessage
                                        name="partyJangadNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="dataEntryUserId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        Data Entry Person
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.dataEntryUserId &&
                                          touched.dataEntryUserId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="dataEntryUserId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.dataEntryList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="dataEntryUserId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="graderUserId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Grader Name")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.graderUserId &&
                                          touched.graderUserId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="graderUserId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.graderList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="graderUserId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  {this.state.props.isEdit != 1 ? (
                                    <div className="mb-3 row px-3 pt-3">
                                      <Label
                                        htmlFor="status"
                                        className="col-md-2 col-form-label"
                                      >
                                        <h5 className="text-secondary fw-bold">
                                          {this.props.t("Status")}
                                        </h5>
                                      </Label>
                                      <div className="col-md-10">
                                        <Field
                                          className={
                                            "form-control fs-5" +
                                            (errors.status && touched.status
                                              ? " is-invalid"
                                              : "")
                                          }
                                          disabled={
                                            this.state.props.isEdit == 3
                                              ? true
                                              : false
                                          }
                                          // readOnly={true}
                                          type="text"
                                          name="status"
                                          as="select"
                                        >
                                          <option value="" disabled>
                                            Select
                                          </option>
                                          <option value="true">True</option>
                                          <option value="false">False</option>
                                        </Field>
                                        <ErrorMessage
                                          name="status"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </Row>
                              </CardBody>
                            </div>
                            <div className="col-xl-4 col-12 pt-3">
                              <div className="px-4">
                                <div className="row border-gray py-3">
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Contact Person")} :</h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty
                                            .contactPersonName
                                        : this.state.props.data.mainJangad.party
                                            .contactPersonName}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.1")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91{" "}
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.mobileNo1
                                        : this.state.props.data.mainJangad.party
                                            .mobileNo1}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.2")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91{" "}
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.mobileNo2
                                        : this.state.props.data.mainJangad.party
                                            .mobileNo2}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Email Address")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.email
                                        : this.state.props.data.mainJangad.party
                                            .email}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {this.state.props.isEdit == 3 ? (
                            ""
                          ) : (
                            <div className="row px-3 pt-3">
                              <div className="d-flex justify-content-between">
                                <h3 className="fw-bold pb-3 text-black">
                                  {this.props.t("Enter stock Details")}
                                </h3>
                                <button
                                  type="button"
                                  className="bg-transparent border-0"
                                  onClick={() => this.addRow()}
                                >
                                  <img
                                    src="images/dashboard-images/addRow.svg"
                                    alt="add Row"
                                  />
                                </button>
                              </div>
                              <div className="table-responsive">
                                <BootstrapTable
                                  keyField="id"
                                  classes="foo"
                                  headerClasses="background-light fs-5"
                                  footerClasses="background-light fs-5"
                                  data={this.state.stockList}
                                  defaultSorted={defaultSorted}
                                  columns={this.columns1}
                                  cellEdit={cellEditFactory({
                                    mode: "click",
                                    blurToSave: true,
                                    afterSaveCell:() => {
                                  this.setState({
                                    stockList: [...this.state.stockList]
                                  })
                                }
                                    // nonEditableRows: () =>
                                    //   this.state.notEditableRows,
                                  })}
                                />
                                {submitCount > 0 &&
                                this.state.stockList.filter(
                                  x => x.weight > 0 && x.pieces > 0
                                ).length == 0 ? (
                                  <p className="text-danger">
                                    Enter minimum one record
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}

                          <div className="row px-3 pt-4">
                            <div>
                              <h3 className="fw-bold pb-3 text-black">
                                {this.props.t("Stock summary")}
                              </h3>
                            </div>

                            <div className="table-responsive">
                              <BootstrapTable
                                classes="foo"
                                keyField="id"
                                defaultSorted={defaultSorted}
                                headerClasses="background-light fs-5"
                                footerClasses="background-light fs-5"
                                bootstrap4={true}
                                data={this.state.stockList}
                                columns={this.columns1}
                              />
                            </div>
                          </div>

                          <div className="mb-3 row px-3 pt-3">
                            <Label
                              htmlFor="selfInternalRemarks"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                Self Internal Remarks
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.selfInternalRemarks &&
                                  touched.selfInternalRemarks
                                    ? " is-invalid"
                                    : "")
                                }
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                                // readOnly={true}
                                type="text"
                                name="selfInternalRemarks"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="selfInternalRemarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          <div className="mb-3 row px-3 pt-3">
                            <Label
                              htmlFor="dataEntryPersonRemarks"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                Data Entry Person Remark
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.dataEntryPersonRemarks &&
                                  touched.dataEntryPersonRemarks
                                    ? " is-invalid"
                                    : "")
                                }
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                                // readOnly={true}
                                type="text"
                                name="dataEntryPersonRemarks"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="dataEntryPersonRemarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>
                          {/* <div className="mb-3 row px-3 pt-3">
                            <Label
                              htmlFor="remarks"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                Remarks
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.remarks && touched.remarks
                                    ? " is-invalid"
                                    : "")
                                }
                                // readOnly={true}
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                                type="text"
                                name="remarks"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="remarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div> */}
                          <div className="mb-3 row px-3 pt-3">
                            <Label
                              htmlFor="graderRemarks"
                              className="col-md-2 col-form-label"
                            >
                              <h5 className="text-secondary fw-bold">
                                {this.props.t("Grader Remarks")}
                              </h5>
                            </Label>
                            <div className="col-md-10">
                              <Field
                                className={
                                  "form-control fs-5" +
                                  (errors.graderRemarks && touched.graderRemarks
                                    ? " is-invalid"
                                    : "")
                                }
                                disabled={
                                  this.state.props.isEdit == 3 ? true : false
                                }
                                type="text"
                                name="graderRemarks"
                                as="textarea"
                                rows="5"
                              />
                              <ErrorMessage
                                name="graderRemarks"
                                component="div"
                                className="invalid-feedback"
                              />
                            </div>
                          </div>

                          <div className="col-md-12 text-center text-md-end pe-3 py-5">
                            <Button
                              color="primary"
                              className="fs-4 px-5"
                              type="submit"
                              onClick={() => this.state.history.goBack()}
                            >
                              Back
                            </Button>

                            {this.state.props.isEdit != 3 &&
                              this.state.isSubmitTrue == true && (
                                <Button
                                  color="primary"
                                  className="fs-4 ms-3 px-5"
                                  type="submit"
                                  onClick={() =>
                                    this.handleSubmit(event, values)
                                  }
                                >
                                  {this.state.props.isEdit == 2
                                    ? "Update"
                                    : "Submit"}
                                </Button>
                              )}
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Card>
              ) : (
                <Card>
                  <Formik
                    enableReinitialize={true}
                    initialValues={
                      this.state.props.isEdit == 1
                        ? {
                            id: "",
                            partyId: this.state.selectedParty.id || "",
                            factoryId: this.state.factoryId || "",
                            userId: "",
                            fromDeliverBoyId: "",
                            weight: 0,
                            pieces: 0,
                            partyJangadNo: "",
                            selfInternalRemarks: "",
                            dataEntryPersonRemarks: "",
                            factoryType: this.state.factoryType,
                            categoryId: this.state.categoryId,
                          }
                        : {
                            categoryId: this.state.categoryId,
                            id: this.state.props.data.id,
                            partyId: this.state.props.data.mainJangad.partyId,
                            factoryId: this.state.props.data.factoryId,
                            userId: tempData.user.id,
                            fromDeliverBoyId: tempData.fromDeliverBoyId,
                            weight: tempData.weight,
                            partyJangadNo:
                              this.state.props.data.mainJangad.partyJangadNo,
                            selfInternalRemarks: tempData.remarks,
                            dataEntryPersonRemarks: tempData.nextRemarks,
                            pieces: tempData.pieces,
                            status:
                              this.state.status == true ? "true" : "false",
                          }
                    }
                    validationSchema={Yup.object().shape({
                      id: Yup.string().notRequired(),
                      partyId: Yup.string().required("This value is required"),
                      factoryId: Yup.string().required(
                        "This value is required"
                      ),
                      userId: Yup.string().required("This value is required"),
                      partyJangadNo: Yup.string().required(
                        "This value is required"
                      ),
                      categoryId: Yup.string().required(
                        "This value is required"
                      ),
                      status: Yup.string().notRequired(),
                      fromDeliverBoyId: Yup.string().required(
                        "This value is required"
                      ),
                      remarks: Yup.string()
                        .max(512)
                        .required("This value is required"),
                      nextremarks: Yup.string()
                        .max(512)
                        .required("This value is required"),
                      weight: Yup.number()
                        .min(1)
                        .max(32767)
                        .required("This value is required"),
                      pieces: Yup.number()
                        .min(1)
                        .max(32767)
                        .required("This value is required"),
                      unitType: Yup.string().required("This value is required"),
                    })}
                    onSubmit={values => {}}
                  >
                    {({
                      errors,
                      status,
                      touched,
                      values,
                      submitCount,
                      resetForm,
                    }) => (
                      <Form className="needs-validation">
                        <div className="pt-3">
                          <div className="row">
                            <div className="d-md-flex d-block justify-content-between px-4">
                              <div>
                                {this.state.props.isEdit == 1 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.props.t("Add New Stock (Inward)")}
                                  </h4>
                                )}
                                {this.state.props.isEdit == 2 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.props.t("Edit Stock (Inward)")}
                                  </h4>
                                )}
                                {this.state.props.isEdit == 3 && (
                                  <h4 className="text-black fw-bold mb-4">
                                    View Stock (Inward)
                                  </h4>
                                )}
                              </div>
                            </div>
                            <div className="col-xl-8 col-12">
                              <CardBody>
                                <Row>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="factoryType"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Factory(Unit) Type")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        onChange={e =>
                                          this.setState(
                                            {
                                              factoryType: e.target.value,
                                              factoryId: "",
                                              factoryList: [],
                                              dataEntryList: [],
                                              deliveryBoyList: [],
                                              salesOfficeList: [],
                                              graderList: [],
                                            },
                                            () => this.getStockList()
                                          )
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        value={this.state.factoryType}
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.factoryType &&
                                          touched.factoryType
                                            ? " is-invalid"
                                            : "")
                                        }
                                        name="factoryType"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        <option value="1">Internal</option>
                                        <option value="2">External</option>
                                      </Field>
                                      <ErrorMessage
                                        name="factoryType"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="id"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Jangad Id")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.id && touched.id
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={true}
                                        type="text"
                                        name="id"
                                        placeholder="JANGAD0000123"
                                      />
                                      <ErrorMessage
                                        name="id"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Name")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.partyId && touched.partyId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.selectedParty.id}
                                        onChange={e =>
                                          this.setState({
                                            selectedParty:
                                              this.state.partyList.filter(
                                                x => x.id == e.target.value
                                              )[0],
                                          })
                                        }
                                        name="partyId"
                                        as="select"
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.partyList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="partyId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="factoryId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Unit Name")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.factoryId && touched.factoryId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        value={this.state.factoryId}
                                        onChange={e => {
                                          resetForm({
                                            ...values,
                                            userId: "",
                                            dataEntryUserId: "",
                                            fromDeliverBoyId: "",
                                            graderUserId: "",
                                            factoryType: "",
                                          });
                                          this.setState(
                                            {
                                              factoryId: e.target.value,
                                              dataEntryList: [],
                                              deliveryBoyList: [],
                                              salesOfficeList: [],
                                              graderList: [],
                                            },
                                            () => {
                                              console.log(this.state.factoryId);
                                              this.getUserLists();
                                            }
                                          );
                                        }}
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="factoryId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.factoryList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="factoryId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="categoryId"
                                      className="col-lg-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Category")}
                                      </h5>
                                    </Label>
                                    <div className="col-lg-10 col-12">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.categoryId &&
                                          touched.categoryId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="categoryId"
                                        as="select"
                                        value={this.state.categoryId}
                                        onChange={e => {
                                          this.setState({
                                            categoryId: e.target.value,
                                          });
                                        }}
                                      >
                                        <option value="">
                                          Select categories
                                        </option>
                                        {this.state.categoryList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="category"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="pieces"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Total No of Pieces")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.pieces && touched.pieces
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="number"
                                        onWheel={e => e.target.blur()}
                                        name="pieces"
                                        placeholder="2001"
                                      />
                                      <ErrorMessage
                                        name="pieces"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="weight"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Total Weight")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.weight && touched.weight
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="number"
                                        onWheel={e => e.target.blur()}
                                        name="weight"
                                        placeholder="20.25 CT"
                                      />
                                      <ErrorMessage
                                        name="weight"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="fromDeliverBoyId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("From Delivery Boy")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.fromDeliverBoyId &&
                                          touched.fromDeliverBoyId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="fromDeliverBoyId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.deliveryBoyList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="fromDeliverBoyId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="userId"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Sales Person")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${
                                            this.state.props.isEdit != 3
                                              ? "form-select"
                                              : ""
                                          } fs-5` +
                                          (errors.userId && touched.userId
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        name="userId"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        {this.state.salesOfficeList?.map(x => (
                                          <option key={x.id} value={x.id}>
                                            {x.name}
                                          </option>
                                        ))}
                                      </Field>
                                      <ErrorMessage
                                        name="userId"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="partyJangadNo"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Party Jangad Number")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.partyJangadNo &&
                                          touched.partyJangadNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        readOnly={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        type="text"
                                        name="partyJangadNo"
                                        placeholder="JANGAD0000123"
                                      />
                                      <ErrorMessage
                                        name="partyJangadNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row px-3 pt-3">
                                    <Label
                                      htmlFor="selfInternalRemarks"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Self Internal Remarks")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.selfInternalRemarks &&
                                          touched.selfInternalRemarks
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        // readOnly={true}
                                        type="text"
                                        name="selfInternalRemarks"
                                        as="textarea"
                                        rows="5"
                                      />
                                      <ErrorMessage
                                        name="selfInternalRemarks"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row px-3 pt-3">
                                    <Label
                                      htmlFor="dataEntryPersonRemarks"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t(
                                          "Data Entry Person Remark"
                                        )}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.dataEntryPersonRemarks &&
                                          touched.dataEntryPersonRemarks
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isEdit == 3
                                            ? true
                                            : false
                                        }
                                        // readOnly={true}
                                        type="text"
                                        name="dataEntryPersonRemarks"
                                        as="textarea"
                                        rows="5"
                                      />
                                      <ErrorMessage
                                        name="dataEntryPersonRemarks"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>

                                  {this.state.props.isEdit != 1 ? (
                                    <div className="mb-3 row px-3 pt-3">
                                      <Label
                                        htmlFor="status"
                                        className="col-md-2 col-form-label"
                                      >
                                        <h5 className="text-secondary fw-bold">
                                          {this.props.t("Status")}
                                        </h5>
                                      </Label>
                                      <div className="col-md-10">
                                        <Field
                                          className={
                                            "form-control fs-5" +
                                            (errors.status && touched.status
                                              ? " is-invalid"
                                              : "")
                                          }
                                          disabled={
                                            this.state.props.isEdit == 3
                                              ? true
                                              : false
                                          }
                                          // readOnly={true}
                                          type="text"
                                          name="status"
                                          as="select"
                                        >
                                          <option value="" disabled>
                                            Select
                                          </option>
                                          <option value="true">True</option>
                                          <option value="false">False</option>
                                        </Field>
                                        <ErrorMessage
                                          name="status"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </Row>
                              </CardBody>
                            </div>
                            <div className="col-xl-4 col-12 pt-3">
                              <div className="px-4">
                                <div className="row border-gray py-3">
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Contact Person")} :</h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty
                                            .contactPersonName
                                        : this.state.props.data.mainJangad.party
                                            .contactPersonName}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.1")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91{" "}
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.mobileNo1
                                        : this.state.props.data.mainJangad.party
                                            .mobileNo1}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Mobile no.2")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      +91{" "}
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.mobileNo2
                                        : this.state.props.data.mainJangad.party
                                            .mobileNo2}
                                    </h5>
                                  </div>
                                  <div className="col-md-5 col-12 pt-2">
                                    <h5>{this.props.t("Email Address")} : </h5>
                                  </div>
                                  <div className="col-md-7 col-12 pt-2">
                                    <h5>
                                      {this.state.props.isEdit == 1
                                        ? this.state.selectedParty.email
                                        : this.state.props.data.mainJangad.party
                                            .email}
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12 text-center text-md-end pe-3 py-5">
                            <Button
                              color="primary"
                              className="fs-4 px-5"
                              type="submit"
                              onClick={() => this.state.history.goBack()}
                            >
                              Back
                            </Button>

                            {this.state.props.isEdit != 3 &&
                              this.state.isSubmitTrue == true && (
                                <Button
                                  color="primary"
                                  className="fs-4 ms-3 px-5"
                                  type="submit"
                                  onClick={() =>
                                    this.externalSubmit(event, values)
                                  }
                                >
                                  {this.state.props.isEdit == 2
                                    ? "Update"
                                    : "Submit"}
                                </Button>
                              )}
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Card>
              )}
            </>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(InternalUnitinward);
